<template lang="pug">
	.preview-settings(v-if="showed && preview" v-window)
		.card
			.card-header
				i.fa.fa-edit
				span Preview Settings
				.preview-id Preview id: {{preview.id}}
			.card-body.collapse.show
				.settings-and-frame.separator
					.settings-container
						.screenshot-and-video
							.screenshot
								.screenshot-container
									img(v-if="preview.options?.screenshotExist" :src="screenshotSrc")
									.empty(v-else) No screenshot
								.screenshot-controls
									.control.remove(@click="removeScreenshot($event)" :class="{disable: !preview.options?.screenshotExist || isPortfolioBlock()}" v-b-tooltip.hover="{delay: { show: 1000, hide: 100 }, title: 'Remove preview image'}")
										i.fa.fa-remove
									.control.upload(@click="uploadScreenshot()" :class="{disable: isPortfolioBlock()}" v-b-tooltip.hover="{delay: { show: 1000, hide: 100 }, title: 'Upload external preview image'}")
										i.fa.fa-upload
									.control.capture(@click="captureScreenshot()" :class="{disable: !preview.options?.videoExist || isPortfolioBlock()}" v-b-tooltip.hover="{delay: { show: 1000, hide: 100 }, title: 'Save video frame as screenshot'}")
										i.fa.fa-camera
							.video
								.video-container(@mousedown="startVideoDrag($event)" @mousemove="dragVideo($event)" @mouseup="toggleVideo($event)")
									video(ref="video" v-if="preview.options?.videoExist" :src="videoSrc" @timeupdate="videoTimeUpdate()" crossorigin="anonymous" playsinline autoplay loop muted)
									.empty(v-else) No video
									.video-progress(v-if="preview.options?.videoExist" @click="dragVideo($event, true)" @mousedown.stop @mouseup.stop)
										.dot(:style="{left: (videoProgress * 142 - 5) + 'px'}")
								.video-controls
									.control.remove(@click="removeVideo($event)" :class="{disable: !preview.options?.videoExist || isPortfolioBlock()}" v-b-tooltip.hover="{delay: { show: 1000, hide: 100 }, title: 'Remove video file'}")
										i.fa.fa-remove
									.control.upload(@click="uploadVideo()" :class="{disable: isPortfolioBlock()}" v-b-tooltip.hover="{delay: { show: 1000, hide: 100 }, title: 'Upload external .mp4 video file'}")
										i.fa.fa-upload
									.control.record(v-if="!videoRecording" @click="toggleRecordVideo" :class="{disable: isPortfolioBlock()}" v-b-tooltip.hover="{delay: { show: 1000, hide: 100 }, title: 'Start record video'}")
										i.fa.fa-video-camera
									.control.record.warning(v-if="videoRecording" @click="toggleRecordVideo" :class="{disable: isPortfolioBlock()}" v-b-tooltip.hover="{delay: { show: 1000, hide: 100 }, title: 'Stop record video'}")
										i.fa.fa-video-camera
						.genres(v-if="Access.check('portfolio-access')")
							.exist-genres
								.exist-genre
									button.btn.btn-sm.favorite-button(type="button" :class="preview['is_favorite'] ? 'btn-warning' : 'btn-outline-secondary'" v-on:click="toggleFavorite()")
										i.fa.fa-star
										span Favorite
								.exist-genre(v-for="(tmp, genreCodename) in preview.Genres")
									button.btn.btn-sm.btn-outline-secondary(type="button" v-on:click="removeGenre($event, genreCodename)") {{Metadata.GenresByCodename[genreCodename]?.title || genreCodename}}
								button.btn.btn-sm.btn-ghost-secondary.add-button(type="button" v-on:click="addGenre($event)")
									i.fa.fa-plus
									span Add genre
					.frame-container
						.frame-record(:class="{animated: videoRecording}")
							iframe.preview-settings-iframe(ref="iframe" :srcdoc="frameContent" frameborder="0" allow="autoplay" allowfullscreen)
				.external.separator(v-if="preview.options?.externalUrl")
					.form-group-horizontal
						label.col-form-label Playable url:
						input.form-control(size="16" type="text" v-model="externalUrl" @change="saveExternalUrl()")
						button.btn.btn-link(type="button" v-on:click="openExternalUrl()")
							i.fa.fa-share
							span Open playable url
				.progress.add-progress(:style="{visibility: preview.isUploading ? 'visible' : 'hidden'}")
					.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (preview.uploadProgress * 100) + '%'}")
				.form-actions
					button.btn.btn-warning(v-if="Access.check('portfolio-access') && !preview['in_portfolio']" type="button" v-on:click="publishInPortfolio()" :disabled="!preview.options?.screenshotExist || !preview.options?.videoExist || !preview.genres")
						i.fa.fa-share
						span Publish to portfolio
					button.btn.btn-warning(v-else-if="Access.check('portfolio-access')" type="button" v-on:click="removeFromPortfolio()")
						i.fa.fa-remove
						span Remove from portfolio
					button.btn.btn-primary(v-if="Access.check('portfolio-access')" type="button" v-on:click="openPortfolio()")
						i.fa.fa-map-o
						span Portfolio
					button.btn.btn-danger(v-if="preview" type="button" @click="deletePreview($event)" :disabled="preview['in_portfolio'] === 1")
						i.fa.fa-remove
						span Delete preview
					button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen';
	import { Auth } from "../../services/Auth";

	import { Creative } 			from '../../services/Creative';
	import { Version } 			from '../../services/Version';
	import { Settings } 		from '../../services/Settings';

	export default {
		name: "PreviewSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Preview Data Upload Progress",
				// События вида Selected Version Preview ... использовать нельзя так как не все preview принадлежат к какой-то версии
 				"Preview Changed: [options.screenshotExist]",
				"Preview Changed: [options.videoExist]",
				"Preview Changed: [options.indexContent]",
				"Preview Changed: [in_portfolio]",
				"Preview Changed: [Genres]",
				"Preview Changed: [is_favorite]"
			],
			events: {
				"Show Preview Settings": function(preview) {

					this.preview = preview;

					this.show();

				}
			}
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.preview = null;

			return {
				frameContent: '',
				screenshotSrc: '',
				videoSrc: '',
				videoRecording: false,
				videoProgress: 0,
				videoDrag: null,
				externalUrl: ''
			}

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				this.stopVideoDrag();

			});

		},
		methods: {
			collectData() {

				if (!this.preview) return;

				this.preview = Preview.Previews[this.preview.id]; // обновим ссылку на актуальный объект

				this.frameContent = Preview.getPreviewIndexContent(this.preview);
				this.screenshotSrc = Preview.getPreviewScreenshotUrl(this.preview);
				this.videoSrc = Preview.getPreviewVideoUrl(this.preview);

				if (this.preview.options?.externalUrl) this.externalUrl = this.preview.options.externalUrl;

			},
			uploadScreenshot() {

				if (this.isPortfolioBlock()) return;

				this.uploadProgress = 0;

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png";

				input.addEventListener('change', e => {

					this.uploadScreenshotFile(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', e => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadScreenshotFile(file) {

				let formData = new FormData();

				formData.append("previewId", this.preview.id);
				formData.append("file", file);

				let url = `${location.protocol}//${SetupSettings["domain"]}/preview/screenshot`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.uploadProgress = e.loaded / e.total;

					}

				};

				xhr.upload.onloadstart = e => {

					this.isUploading = true;

				};

				xhr.upload.onloadend = e => {

					this.isUploading = false;

				};

				xhr.send(formData);

			},
			captureScreenshot() {

				if (!this.preview.options?.videoExist) return;

				if (this.isPortfolioBlock()) return;

				console.log('captureScreenshot1');

				const video = this.$refs?.video;
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');

				console.log('captureScreenshot2');

				canvas.width = video.videoWidth;
				canvas.height = video.videoHeight;
				ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

				console.log('captureScreenshot3');

				const base64Data = canvas.toDataURL("image/png", 1);

				console.log('captureScreenshot4');

				let formData = new FormData();

				formData.append("previewId", this.preview.id);
				formData.append("screenshotData", base64Data);

				let url = `http://${SetupSettings["domain"]}/preview/screenshot`;
				if (location.protocol === 'https:') url = `https://${SetupSettings["domain"]}/preview/screenshot`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.preview.uploadProgress = e.loaded / e.total;
						Broadcast.call('Preview Data Upload Progress', [this.preview]);

					}

				};

				xhr.upload.onloadstart = ()=>{

					this.preview.isUploading = true;
					Broadcast.call('Preview Data Upload Progress', [this.preview]);

				};

				xhr.upload.onloadend = ()=>{

					this.preview.isUploading = false;
					Broadcast.call('Preview Data Upload Progress', [this.preview]);

				};

				xhr.send(formData);

			},
			removeScreenshot(e) {

				if (!this.preview.options?.screenshotExist) return;

				if (this.isPortfolioBlock()) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete preview screenshot',
					message: `Are you sure you want to delete screenshot?`,
					confirmButtonText: '&nbsp;&nbsp;Delete screenshot',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {

						Server.sendToServer({
							RemovePreviewScreenshot: {
								previewId: this.preview.id
							}
						});

					}
				}]);

			},
			uploadVideo() {

				if (this.isPortfolioBlock()) return;

				this.uploadProgress = 0;

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "video/mp4";

				input.addEventListener('change', e => {

					this.uploadVideoFile(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', e => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadVideoFile(file) {

				let formData = new FormData();

				formData.append("previewId", this.preview.id);
				formData.append("file", file, "video.mp4");

				let url = `${location.protocol}//${SetupSettings["domain"]}/preview/video`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.uploadProgress = e.loaded / e.total;

					}

				};

				xhr.upload.onloadstart = e => {

					this.isUploading = true;

				};

				xhr.upload.onloadend = e => {

					this.isUploading = false;

				};

				xhr.send(formData);

			},
			toggleRecordVideo() {

				if (this.isPortfolioBlock()) return;

				if (!this.videoRecording) this.startRecordVideo();
				else this.stopRecordVideo();

			},
			startRecordVideo() {

				if (this.isPortfolioBlock()) return;

				this.videoRecording = true;

				this.sendToPreviewFrame({StartRecordVideo: true});

			},
			stopRecordVideo() {

				if (this.isPortfolioBlock()) return;

				this.videoRecording = false;

				this.sendToPreviewFrame({StopRecordVideo: true});

				Broadcast.once(`IFrame Data:VideoUrl`, async videoUrl => {

					const response = await fetch(videoUrl);
					const blob = await response.blob();

					let formData = new FormData();

					formData.append("previewId", this.preview.id);
					formData.append("file", blob, "video.mp4");

					let url = `http://${SetupSettings["domain"]}/preview/video`;
					if (location.protocol === 'https:') url = `https://${SetupSettings["domain"]}/preview/video`;

					let xhr = new XMLHttpRequest();


					xhr.open("POST", url);
					Auth.authorizeRequest(xhr);

					xhr.upload.onprogress = e => {

						if (e.lengthComputable) {

							this.preview.uploadProgress = e.loaded / e.total;
							Broadcast.call('Preview Data Upload Progress', [this.preview]);

						}

					};

					xhr.upload.onloadstart = ()=>{

						this.preview.isUploading = true;
						Broadcast.call('Preview Data Upload Progress', [this.preview]);

					};

					xhr.upload.onloadend = ()=>{

						this.preview.isUploading = false;
						Broadcast.call('Preview Data Upload Progress', [this.preview]);

					};

					xhr.send(formData);

				});

			},
			toggleVideo(e) {

				if (this.videoDrag && Math.abs(e.clientX - this.videoDrag.x) < 3 && Math.abs(e.clientY - this.videoDrag.y) < 3) {

					if (this.$refs.video.paused) this.$refs.video.play();
					else this.$refs.video.pause();

				}

			},
			startVideoDrag(e) {

				if (!this.$refs?.video) return;

				this.videoDrag = {x: e.clientX, y: e.clientY};

				//this.dragVideo(e);

			},
			dragVideo(e, force = false) {

				if (this.videoDrag || force) {

					let videoDimensions = this.$refs?.video.getBoundingClientRect();

					let x = e.clientX - videoDimensions.left,
						percent = x / videoDimensions.width;

					if (percent < 0) percent = 0;
					if (percent > 1) percent = 1;

					this.$refs.video.currentTime = this.$refs.video.duration * percent;

				}

			},
			videoTimeUpdate() {

				const video = this.$refs?.video;

				this.videoProgress = video.currentTime / video.duration;

			},
			stopVideoDrag() {

				this.videoDrag = false;

			},
			removeVideo(e) {

				if (!this.preview.options?.videoExist) return;

				if (this.isPortfolioBlock()) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete preview video',
					message: `Are you sure you want to delete video?`,
					confirmButtonText: '&nbsp;&nbsp;Delete video',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {

						Server.sendToServer({
							RemovePreviewVideo: {
								previewId: this.preview.id
							}
						});

					}
				}]);

			},
			sendToPreviewFrame(data) {

				if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage(data, '*');

			},
			addGenre(e) {

				Broadcast.call("Show PreviewGenreAdd", [e.target.closest('.btn'), this.preview])

			},
			toggleFavorite() {

				Server.sendToSocket({
					SetPreviewFavorite: {
						previewId: this.preview.id,
						isFavorite: !this.preview['is_favorite']
					}
				});

			},
			removeGenre(e, genreCodename) {

				Broadcast.call('Show Confirm', [{
					caption: 'Remove preview genre',
					message: `Are you sure you want to remove genre "${Metadata.GenresByCodename[genreCodename]?.title || genreCodename}"?`,
					confirmButtonText: '&nbsp;&nbsp;Remove genre',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {

						Server.sendToSocket({
							RemovePreviewGenre: {
								previewId: this.preview.id,
								genreCodename: genreCodename
							}
						});

					}
				}]);

			},
			saveExternalUrl() {

				Server.sendToSocket({
					SavePreviewExternalUrl: {
						previewId: this.preview.id,
						externalUrl: this.externalUrl
					}
				});

			},
			openExternalUrl() {

				window.open(this.externalUrl, "_blank");

			},
			publishInPortfolio() {

				Server.sendToServer({
					AddPreviewToPortfolio: {
						previewId: this.preview.id
					}
				});

			},
			removeFromPortfolio() {

				Server.sendToServer({
					RemovePreviewFromPortfolio: {
						previewId: this.preview.id
					}
				});

			},
			openPortfolio() {

				Broadcast.call("Show Portfolio");

			},
			isPortfolioBlock() {

				return this.preview['in_portfolio'] && !Access.check('portfolio-access');

			},
			deletePreview(e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete preview',
					message: `Are you sure you want to delete this preview?`,
					confirmButtonText: '&nbsp;&nbsp;Delete preview',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {

						Server.sendToSocket({
							DeletePreview: this.preview.id
						});

						this.hide();

					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.preview-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.preview-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 0px

		.card
			display: flex
			width: 625px
			margin: auto
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			.settings-and-frame
				display: flex
				flex-direction: row

				.settings-container
					display: flex
					flex-direction: column
					width: 330px

					.screenshot-and-video
						display: flex
						flex-direction: row
						border-bottom: 1px solid rgba(0, 0, 0, 0.3)
						padding-bottom: 10px

						.screenshot
							display: flex
							flex-direction: column

							.screenshot-container
								border: 1px solid var(--secondary)
								margin: 3px 10px
								width: 142px
								height: 250px
								overflow: hidden

								img
									width: 100%

							.screenshot-controls
								display: flex
								flex-direction: row
								justify-content: center
								align-items: center

								.control
									padding: 5px
									cursor: pointer
									font-size: 20px

									&:hover
										color: var(--primary)

								.control.upload
									font-size: 16px
									margin-top: 1px
									margin-left: 10px

								.control.remove

									&:hover
										color: var(--danger)

								.control.capture
									font-size: 18px
									margin-top: 3px
									margin-left: 10px

								.control.disable
									opacity: 0.2
									cursor: default

									&:hover
										color: #e4e7ea

						.video

							.video-container
								border: 1px solid var(--secondary)
								margin: 3px 10px
								width: 142px
								height: 250px
								overflow: hidden
								position: relative

								video
									width: 100%

								.video-progress
									position: absolute
									bottom: 5px
									left: 0
									width: 100%
									height: 5px
									background-color: rgba(0,0,0,0.2)
									visibility: hidden
									cursor: pointer

									.dot
										position: absolute
										bottom: -2px
										width: 9px
										height: 9px
										border-radius: 9px
										background-color: var(--primary)
										transition: left 0.1s linear

							.video-container:hover

								.video-progress
									visibility: visible

							.video-controls
								display: flex
								flex-direction: row
								justify-content: center
								align-items: center

								.control
									padding: 5px
									cursor: pointer
									font-size: 20px

									&:hover
										color: var(--primary)

								.control.upload
									font-size: 16px
									margin-top: 1px
									margin-left: 10px

								.control.remove

									&:hover
										color: var(--danger)

								.control.record
									font-size: 18px
									margin-top: 3px
									margin-left: 10px

									&.warning
										color: var(--warning)

								.control.disable
									opacity: 0.2
									cursor: default

									&:hover
										color: #e4e7ea

						.empty
							display: flex
							width: 100%
							height: 100%
							justify-content: center
							align-items: center

					.genres

						.exist-genres
							display: flex
							flex-direction: row
							flex-wrap: wrap
							width: 100%

							.exist-genre
								display: flex
								padding-top: 10px

								.btn
									margin-right: 20px
									white-space: nowrap

								.favorite-button

									i
										margin-right: 5px

						.add-button
							margin-top: 10px
							white-space: nowrap
							margin-right: 20px

							i
								margin-right: 10px

				.frame-container
					font-size: 0
					margin-left: 20px

					.frame-record
						width: 232px
						height: 407px

					.frame-record.animated
						animation: border-pulse 1s infinite alternate ease-in-out

					iframe
						//border: 1px solid var(--secondary)
						width: 452px
						height: 802px
						transform-origin: left top
						transform: scale(0.5)

			.external
				margin-top: 20px

				.form-group-horizontal
					display: flex
					flex-direction: row

					label
						white-space: nowrap
						margin-right: 20px

					button
						white-space: nowrap
						margin-left: 20px

						i
							margin-right: 10px

					button:hover
						color: var(--primary)

			.progress.add-progress
				height: 5px
				margin-top: 5px
				margin-bottom: 7px

			.form-actions
				display: flex
				flex-direction: row
				margin-top: 5px

				button.video

				.btn-danger, .btn-primary, .btn-warning
					white-space: nowrap
					margin-right: 20px

					i
						margin-right: 10px

				.btn-ghost-dark, .btn-dark
					margin-left: auto

		@keyframes border-pulse
			0%
				border-color: rgba(255,0,0,1)
			50%
				border-color: rgba(255,0,0,0)
			100%
				border-color: rgba(255,0,0,1)

	.preview-settings.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>

